const colors = Object.freeze({
    green: '#00b050',
    lightGreen: '#92d050',
    yellow: '#ffff00',
    orange: '#ffc000',
    red: '#ff0000',
    black: '#000000',
    text: '#0a0a0a',
});

export default colors;